module.exports = __webpack_public_path__ + "static/media/layout-4.3e2a4317.svg";